import React from "react";
import { Container, Grid, Typography, Box, Button } from "@mui/material";
import "./Loginpassword.css";
import { useNavigate } from "react-router-dom";

const Pages = () => {
  const navigate= useNavigate();
  return (
    <Container maxWidth="lg" sx={{ py: 3 }}>
      <Box display={"flex"} justifyContent={"space-between"}>
      <Typography
        variant="h4"
        fontWeight="bold"
        textAlign={{ md: "center", sm: "left" }}
        gutterBottom
      >
        Pages
      </Typography>
      <Button color="inherit" onClick={() => navigate("/helpcenterlayout")}>
          Back to Home
        </Button>
        </Box>

      <Grid
        container
        spacing={4}
        alignItems="center"
        direction={{ xs: "column", md: "row" }} // Image first on mobile
      >
        {/* Text Section */}
        <Grid size={{ xs: 12, md: 6 }} item xs={12} md={6}>
          <Typography variant="h6" fontWeight="bold" gutterBottom>
            User-friendly variant page designs
          </Typography>

          <Typography variant="body1" paragraph>
            TA Wallet is a comprehensive digital platform built to simplify and
            secure your everyday financial tasks. With a clean, user-friendly
            interface, it gives access to services like bill payments,
            insurance, travel bookings, and more. Everything you need is
            available in one place—fast, easy, and convenient.
          </Typography>

          <Typography variant="body1" paragraph>
            The Bill Payments section lets users pay electricity, water, gas,
            and broadband bills effortlessly. It also allows easy insurance
            premium payments, so you never miss a due date. For travel, you can
            book buses, flights, and hotels—all within the app.
          </Typography>

          <Typography variant="body1" paragraph>
            TA Wallet supports Rupay prepaid cards for secure, contactless
            transactions anywhere. Users can instantly load money from their
            bank and manage it within the wallet. Funds can also be transferred
            directly to bank accounts quickly and safely.
          </Typography>

          <Typography variant="body1">
            In summary, TA Wallet is your smart daily finance companion—secure,
            reliable, and fast. Its integrated services save time by eliminating
            the need for multiple apps. Perfect for anyone who values simplicity
            and control in their digital lifestyle.
          </Typography>
        </Grid>

        <Grid size={{ xs: 12, md: 6 }} item xs={12} md={6}>
          <Box
            className="image-wrapper"
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <img
              src="/Assets/gif.gif"
              alt="Login Security"
              className="animated-gif-image"
              style={{
                width: "100%",
                maxHeight: 400,
                objectFit: "contain",
                borderRadius: 12,
              }}
            />
          </Box>
        </Grid>
      </Grid>
    </Container>
  );
};

export default Pages;
